<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <h2>Essential Links</h2>
    <router-link to="/">Go to fierfuer</router-link>

    <ul>
      <li>
        <a href="https://vuejs.org" target="_blank" rel="noopener">Core Docs</a>
      </li>
      <li>
        <a href="https://forum.vuejs.org" target="_blank" rel="noopener">Forum</a>
      </li>
      <li>
        <a href="http://chat.vuejs.org/" target="_blank" rel="noopener">Vue Community Chat</a>
      </li>
      <li>
        <a href="https://twitter.com/vuejs" target="_blank" rel="noopener">Twitter</a>
      </li>
      <li>
        <a href="http://vuejs-templates.github.io/webpack/" target="_blank" rel="noopener">Docs for This Template</a>
      </li>
    </ul>
    <h2>Ecosystem</h2>
    <ul>
      <li>
        <a href="http://router.vuejs.org/" target="_blank" rel="noopener">vue-router</a>
      </li>
      <li>
        <a href="http://vuex.vuejs.org/" target="_blank" rel="noopener">vuex</a>
      </li>
      <li>
        <a href="http://vue-loader.vuejs.org/" target="_blank" rel="noopener">vue-loader</a>
      </li>
      <li>
        <a href="https://github.com/vuejs/awesome-vue" target="_blank" rel="noopener">awesome-vue</a>
      </li>
    </ul>
    <Footer />
  </div>
</template>

<script>
  import Slick from "vue-slick";
  import {
    makeRequest,
    makeRequestDirect
  } from "@/helper/internet.js";

  export default {
    name: "homepage",
    components: {
      Slick
    },
    metaInfo: {
      title: "perfect",
      titleTemplate: null
    },
    data() {
      return {
        msg: "Movie Listing",
        slickOptions: {
          slidesToShow: 3
        },
        shows: {}
      };
    },
    beforeMount() {
      this.getNowShowingData();
    },
    methods: {
      getNowShowingData: function () {
        let payload = {};
        // console.log('test2', this.dropDowns.cinemaChain.selected)
        // if(this.dropDowns.cinemaChain.selected.OrganizationName != 'All Cinemas'){
        // console.log('test3', this.dropDowns.cinemaChain.selected)
        //     payload.organisationID = this.dropDowns.cinemaChain.selected.OrganisationID;
        // }
        // if(this.dropDowns.languages.selected.Title != 'All Languages'){
        //     payload.language = this.dropDowns.languages.selected.Title;
        // };
        // if(this.$persistStore.get("accessToken")){
        //     payload.accessToken = this.$persistStore.get("accessToken");
        // };

        // payload.CountryID = this.getCountryFromLocalStorage().CountryID;
        payload.CountryID = 5;
        payload.LanguageID = 1;
        makeRequestDirect("/GetAllShow/", "POST", null, payload)
          .then(response => {
            const {
              error,
              res
            } = response;
            console.log("movie", error, res);
            if (!error && res.data.Status) {
              const {
                data
              } = res.data;
              let arr = [];
              console.log("t3", res);
              this.shows = res.data;
              res.data.shows.map(x => {
                // x.Movies.map(function(y,_index){
                //     y['url'] =  "/movie-details-page?movieId=" + y.ID;
                //     y['bookingURL'] =  "/movie-details-page?movieId=" + y.ID + '&timing=1';
                // })
              });


            } else {
              console.log("Response Error ");
            }
          })
          .catch(error => {
            console.log("Error", error);
          });
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/components/pages/movieListing.vue